export default "/spa/*";
